
import { RangerMetadataBase } from './ranger.metadata.base';


export class RangerMetadata extends RangerMetadataBase {
  constructor() {
    super();
  }
}

export const RANGER_METADATA: RangerMetadata = new RangerMetadata();


